import { TemplateFormFieldProps } from '../../interfaces/template-form';
import { FormikTextField } from '../../../input/FormikTextField/FormikTextField';
import { TemplateFormTextFieldMeta } from './interfaces/template-form-text-field-meta';

export function TemplateFormTextField({
  field,
  form,
  meta,
  metadata,
  formDisabled
}: TemplateFormFieldProps) {
  const props = metadata as TemplateFormTextFieldMeta;

  return (
    <FormikTextField
      field={field}
      form={form}
      meta={meta}
      name={field.name}
      id={field.name}
      {...props}
      disabled={props.disabled || formDisabled}
    />
  );
}
